export function getCanvasSizeInfo(topOffset: number): {
  width: number;
  height: number;
  dpr: number;
} {
  const viewportWidth = window.innerWidth;
  const viewportHeight = window.innerHeight;
  const dpr = window.devicePixelRatio || 1;
  return {
    width: viewportWidth,
    height: viewportHeight - topOffset,
    dpr,
  };
}
